<template>
	<b-dropdown right variant="link" size="lg" no-caret title="Settings" class="mr-1">
		<template slot="button-content">
			<font-awesome-icon icon="cog"/>
		</template>
		<b-dropdown-item-button @click="edit()">Edit visualization</b-dropdown-item-button>
		<b-dropdown-item-button @click="editQuery()">Edit query</b-dropdown-item-button>
	</b-dropdown>
</template>

<script>
	export default {
		props: ['id', 'data'],
		beforeDestroy() {
			this.$store.commit('visualizations/CLEAR_QUERIES_ID');
		},
		computed: {
			queryId() {
				return this.$store.state.visualizations.queriesId.find(element => {
					return element.id === this.id;
				})
			}
		},
		methods: {
			edit() {
				this.$router.push({ name: 'visualization.edit', params: { visualization_id: this.id } });
			},
			editQuery() {
				this.$router.push({ name: 'query.edit', params: { query_id: this.queryId.queryId } });
			}
		}
	}
</script>

<style lang="scss">
	.btn-link {
		color:#444;
		padding: 0;
		margin-bottom: 0;
	}
	.btn-link:hover {
		color:#444;
	}
</style>
